import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Sale, SaleItem, CustomerType } from '@/lib/types';

export interface SaleInput {
    cart: SaleItem[];
    paymentMethod: string;
    total: number;
    discountAmount?: number;
    customerId?: string;
    customerName?: string;
    customerType?: CustomerType;
    payNow: number;
}

export async function listSales(shopId: number | string): Promise<Sale[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.sales.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function getSale(shopId: number | string, id: number | string): Promise<Sale> {
    const res = await apiClient.get<{ data: any }>(
        API_ENDPOINTS.sales.GET(shopId, id),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function createSale(
    shopId: number | string,
    input: SaleInput
): Promise<Sale> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.sales.CREATE(shopId),
        {
            customerId: input.customerId,
            customerName: input.customerName,
            customerType: input.customerType,
            paymentMethod: input.paymentMethod,
            paidAmount: input.payNow,
            discountAmount: input.discountAmount ?? 0,
            items: input.cart.map((i) => ({
                itemType: i.itemType,
                productId: i.productId,
                serviceId: i.serviceId,
                itemName: i.itemName,
                quantity: i.quantity,
                unitPrice: i.unitPrice,
                originalUnitPrice: i.originalUnitPrice,
                isCommissioned: i.isCommissioned,
                offeringMode: i.offeringMode,
                vendorCost: i.vendorCost,
                commissionEarned: i.commissionEarned,
                vendorId: i.vendorId,
                materialId: i.materialId,
                materialName: i.materialName,
                unitCost: i.unitCost,
                parts: (i as any).parts,
                attributes: (i as any).attributes,
                sku: (i as any).sku,
                discountType: i.discountType,
                discountValue: i.discountValue,
                lineTotal: i.lineTotal,
                advanceAmount: i.advanceAmount,
                balanceAmount: i.balanceAmount,
            })),
        },
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function deleteSale(
    shopId: number | string,
    id: number | string
): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.sales.DELETE(shopId, id), {
        headers: APIHeadersWithAuth(),
    });
}
